
<panel-block id="pn-security-maskable" panel-group>
  <panel-item>
    <!-- form elements use slot and inject legacy fields into slot for determining masking state  --> 
    <slot>
      <row>
        <column>
          <label :for="model.idForProp('security_maskable_enabled')">Mask Sensitive Data</label>
        </column>
        <suffix>
          <help-tooltip text="Masking the data will display it to the end-user as asterisks"></help-tooltip>
        </suffix>
      </row>
      <toggle-select
        :id="model.idForProp('security_maskable_enabled')"
        compress
        v-model="model.security_maskable_enabled"
      />
    </slot>
  </panel-item>
  <template v-if="model[determinantFieldName]">
    <panel-item>
      <row>
        <column>
          <label :for="model.idForProp('security_maskable_full_viewers')">Who Can See the Data Fully Unmasked?</label>
        </column>
        <suffix>
          <help-tooltip text="Only those that are added can see unmasked data. Otherwise, users not added will see fully masked data"></help-tooltip>
        </suffix>
        <permittee-select
          :id="model.idForProp('security_maskable_full_viewers')"
          :permittees="model.securityMaskingFullViewersArray"
          :options="vOptionSets"
          @create="model.appendSecurityMaskableViewers($event, 'security_maskable_full_viewers')"/>
      </row>
    </panel-item>

    <panel-item>
      <row>
        <column>
          <label :for="model.idForProp('security_maskable_partial_viewers')">Who Can See the Data Partially Unmasked?</label>
        </column>
        <suffix>
          <help-tooltip text="Only those that are added can see partially masked data. Otherwise, users not added will see fully masked data"></help-tooltip>
        </suffix>
      </row>
      <permittee-select
        :id="model.idForProp('security_maskable_partial_viewers')"
        :permittees="model.securityMaskingPartialViewersArray"
        :options="vOptionSets"
        @create="model.appendSecurityMaskableViewers($event, 'security_maskable_partial_viewers')"/>
    </panel-item>

    <panel-item>
      <row>
        <column>
          <label :for="model.idForProp('security_maskable_partial_display_character_count')"># Characters to Unmask</label>
        </column>
        <suffix>
          <help-tooltip :text="partialDisplayTooltip"></help-tooltip>
        </suffix>
      </row>

      <number-input
        :id="model.idForProp('security_maskable_partial_display_character_count')"
        v-model="model.security_maskable_partial_display_character_count"
        :replacement-value="0"/>
    </panel-item>
  </template>

</panel-block>
